import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';

/* Mismos colores que los tomos en la imagen del pack */
const TOMO_COLORS = ['bg-green-700 text-white', 'bg-blue-700 text-white', 'bg-red-700 text-white', 'bg-blue-900 text-white', 'bg-red-800 text-white', 'bg-purple-800 text-white'];
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-cream text-pitch" data-id="element-152" data-mp="12rrnrv2efdp">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-153" data-mp="3t7lstip8pegb">
        <p className="inline-block rounded-md bg-field px-2 py-0.5 font-sub text-sm font-extrabold leading-tight text-white" data-id="element-154" data-mp="auxekn6gm6m1">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-2 font-display text-[1.7rem] font-normal uppercase leading-[1.05] sm:text-5xl" data-id="element-155" data-mp="ks214o47w43d">
          <span className="bg-pitch px-1.5 text-gold" data-id="element-156" data-mp="fvblu308lcj0">6 tomos en un solo sistema,</span>{' '}
          creados para aprender desde cero.
        </h2>
        <p className="mt-1.5 font-sub text-xs font-extrabold uppercase leading-tight text-field sm:text-sm" data-id="element-157" data-mp="3b974blvlrhse">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-sm leading-snug text-pitch/80" data-id="element-158" data-mp="3f9zcebsqngn3">
          No es simplemente otro ebook de fútbol. Es una{' '}
          <strong className="font-bold text-pitch" data-id="element-159" data-mp="3p9zyg5hzsauz">ruta de aprendizaje</strong>{' '}
          que organiza los conocimientos necesarios para que comprendas cómo
          enseñar, qué ejercicios aplicar, cómo preparar cada entrenamiento y
          cómo dirigir un equipo con mayor organización.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-160" data-mp="6vqovi52pg1s">
          {tomos.map((tomo, i) => <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full overflow-hidden rounded-xl border-2 border-pitch bg-white text-left text-pitch" data-id="element-161" data-mp="bv3kosdx9xgi" data-mpi={i}>
              <span className={`flex w-14 flex-shrink-0 flex-col items-center justify-center gap-0.5 ${TOMO_COLORS[i]}`} data-id="element-162" data-mp="2cxck4vc805fa">
                <span className="font-sub text-[10px] font-extrabold uppercase tracking-wider" data-id="element-163" data-mp="2mn4je2v9lmq3">
                  Tomo
                </span>
                <span className="font-display text-3xl leading-none" data-id="element-164" data-mp="2hubftibj8kfl">
                  {i + 1}
                </span>
              </span>
              <div className="p-2.5" data-id="element-165" data-mp="2rlply8xzoihp">
                <h3 className="font-sub text-sm font-extrabold leading-tight" data-id="element-166" data-mp="2rknxn2rypzi1">
                  <span className="sr-only" data-id="element-167" data-mp="35m0b97jnhp0r">Tomo {i + 1} — </span>
                  {tomo.title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-pitch/80 sm:text-sm" data-id="element-168" data-mp="30nfan70hl3bs">
                  {tomo.desc}
                </p>
              </div>
            </Reveal>)}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-169" data-mp="169eeitwbmufe">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}